import { createContext, useContext, useState, useEffect } from "react";

export const WHATSAPP = "https://wa.me/393806832210";
export const PHONE = "tel:+393806832210";
export const PHONE_DISPLAY = "380 683 2210";
export const VCALENDAR = "https://www.vcalendar.it/gioiacentroestetico/login";
export const REVIEW_URL = "https://g.page/r/CSVbqpZH6EqqEAE/review";
export const INSTAGRAM = "https://www.instagram.com/gioia.centroestetico";
export const ADDRESS = "Via Tre Fontane, 37 · 88100 Catanzaro CZ";
export const MAPS = "https://www.google.com/maps/search/?api=1&query=Gioia+Centro+Estetico+Via+Tre+Fontane+37+Catanzaro";

const U = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;
export const IMG = {
  hero: "/images/gioia-portrait.jpg",
  cabina: "/images/gioia-cabina.jpg",
  team: "/images/gioia-team.jpg",
  skincareTeam: "/images/gioia-skincare-team.jpg",
  vitc: "/images/gioia-skincare-vitc.jpg",
  realFace: "/images/real-viso.jpg",
  realMassage: "/images/real-massaggio.jpg",
  realDark: "/images/real-gioia-cabina-dark.jpg",
  realBack: "/images/real-massaggio-schiena.jpg",
  realBody: "/images/real-corpo-snellente.jpg",
  realLaser: "/images/real-laser-diodo.jpg",
  realLaserCard: "/images/real-laser-card.jpg",
  facial: U("photo-1643684391140-c5056cfd3436"),
  faceCard: U("photo-1761718210089-ba3bb5ccb54f"),
  massage: U("photo-1639162906614-0603b0ae95fd"),
  body: U("photo-1519823551278-64ac92734fb1"),
  nails: U("photo-1610992015762-45dca7fa3a85"),
  skincare: U("photo-1650529192647-ce4eb5fb3314"),
  serum: U("photo-1613803745799-ba6c10aace85"),
  ritual: U("photo-1675149476008-83dbfa2ee917"),
};

export const SERVICES = [
  { key: "face", img: IMG.realFace, pos: "object-[50%_20%]", it: { t: "Viso & Pro-Age", s: ["Trattamento viso pro-age", "Mesoporazione estetica", "Trattamenti per l'acne"] }, en: { t: "Face & Pro-Age", s: ["Pro-age facial treatment", "Aesthetic mesoporation", "Acne treatments"] } },
  { key: "body", img: IMG.realBody, pos: "object-[50%_60%]", it: { t: "Corpo", s: ["Trattamento corpo snellente", "Mesoterapia estetica", "Lipolaser", "Massaggio"] }, en: { t: "Body", s: ["Slimming body treatment", "Aesthetic mesotherapy", "Lipolaser", "Massage"] } },
  { key: "hands", img: IMG.nails, pos: "object-[60%_75%]", it: { t: "Mani & Piedi", s: ["Manicure", "Pedicure", "Unghie in acrilico"] }, en: { t: "Hands & Feet", s: ["Manicure", "Pedicure", "Acrylic nails"] } },
  { key: "hair", img: IMG.realLaserCard, pos: "object-[50%_40%]", it: { t: "Epilazione", s: ["Depilazione laser", "Ceretta brasiliana"] }, en: { t: "Hair Removal", s: ["Laser hair removal", "Brazilian wax"] } },
];

export const LEGAL = {
  name: "Gioia Centro Estetico di Teresa Anfosso",
  piva: "00000000000",
  rea: "CZ-000000",
  email: "gesteticabenessere@icloud.com",
};

// price: null = buyer chooses the amount (set a number in € to fix the package price)
export const PACKAGES = [
  {
    key: "glow", price: null, page: "/pacchetto-glow-regalo-catanzaro", imgs: ["/images/mesoporazione-estetica.jpg", "/images/crema-vitc-hero.jpg"],
    it: { name: "Pacchetto Glow", label: "Pacchetto Glow: Mesoporazione estetica + Crema viso vitamina C", items: ["1 seduta di Mesoporazione estetica", "Crema viso arancia e vitamina C Gioia Skincare"], desc: "Idratazione profonda in cabina e luminosità ogni mattina a casa: il regalo per una pelle che brilla." },
    en: { name: "Glow Package", label: "Glow Package: Aesthetic mesoporation + Vitamin C face cream", items: ["1 Aesthetic mesoporation session", "Gioia Skincare orange & vitamin C face cream"], desc: "Deep hydration in the salon and radiance every morning at home: the gift for glowing skin." },
  },
];

export const GIFT_PRESETS = [["gift_50", 50], ["gift_100", 100], ["gift_150", 150]];

export const BEFORE_AFTER = [
  { key: "proage", before: "/images/ba-pro-before.jpg", after: "/images/ba-pro-after.jpg", it: { t: "Viso pro-age", d: "Rughe d'espressione attenuate, incarnato più compatto e luminoso." }, en: { t: "Pro-age facial", d: "Softened expression lines, firmer and brighter complexion." } },
  { key: "acne", before: "/images/ba-acne-before.jpg", after: "/images/ba-acne-after.jpg", it: { t: "Trattamento acne", d: "Imperfezioni ridotte, rossori calmati, pori affinati." }, en: { t: "Acne treatment", d: "Fewer breakouts, calmer redness, refined pores." } },
  { key: "body", before: "/images/ba-body-before.jpg", after: "/images/ba-body-after.jpg", it: { t: "Corpo snellente", d: "Addome più piatto e girovita più definito." }, en: { t: "Body slimming", d: "Flatter abdomen and a more defined waistline." } },
];

export const T = {
  it: {
    nav: { about: "Filosofia", services: "Trattamenti", results: "Risultati", skincare: "Skincare", shop: "Shop", gift: "Regala", blog: "Blog", reviews: "Recensioni", contact: "Contatti", book: "Prenota" },
    hero: {
      over: "Centro Estetico · Catanzaro",
      lines: ["La bellezza", "è un rituale", "di precisione."],
      sub: "Trattamenti viso pro-age, rimodellamento corpo e tecnologie avanzate, eseguiti con metodo, igiene impeccabile e la mano esperta di Gioia.",
      cta: "Prenota un trattamento",
      wa: "Scrivici su WhatsApp",
      rating: "26 recensioni Google",
      open: "Apre alle 09:00",
      scroll: "Scorri",
    },
    marquee: ["Viso Pro-Age", "Corpo Snellente", "Mesoterapia Estetica", "Depilazione Laser", "Lipolaser", "Massaggio", "Gioia Skincare", "Manicure"],
    about: {
      over: "01 — Filosofia",
      title: ["Un luogo dove la cura", "diventa", "risultato."],
      p1: "Gioia Centro Estetico nasce da un'idea semplice: ogni trattamento deve essere misurabile. Pelle più luminosa, silhouette più definita, mani sempre curate.",
      p2: "Ascolto, diagnosi, protocollo personalizzato. Nessun passaggio è lasciato al caso, e la pulizia dell'ambiente è parte integrante del rituale.",
      stats: [["4,8", "valutazione media"], ["13", "trattamenti"], ["100%", "protocolli igienizzati"]],
      sign: "— Gioia Anfosso",
      role: "Fondatrice e titolare",
    },
    services: { over: "02 — Trattamenti", title: "Il menu della bellezza", sub: "Sei aree di competenza, un'unica attenzione: la tua pelle.", book: "Prenota", quiz: "Non sai cosa scegliere? Fai il quiz" },
    beforeAfter: {
      over: "03 — Risultati", title: ["Prima", "& dopo"],
      sub: "Trascina il cursore per scoprire la differenza. Ogni percorso è personalizzato e i risultati variano da persona a persona.",
      before: "Prima", after: "Dopo", drag: "Trascina per confrontare",
      disclaimer: "Immagini dimostrative. Presto le foto reali delle nostre clienti.",
    },
    skincare: {
      over: "04 — La linea",
      title: "Gioia Skincare",
      sub: "La nostra linea di cosmetici, nata in cabina e formulata con ingredienti vegetali, per prolungare a casa i risultati dei trattamenti.",
      line: "Linea Nature · ingredienti vegetali",
      products: [["Crema viso arancia", "Vitamina C", "Luminosità e uniformità dell'incarnato."], ["Crema viso calendula", "Pelle sensibile", "Lenitiva e protettiva per le pelli più delicate."]],
      steps: [["Detergere", "Texture delicate che rispettano il film idrolipidico."], ["Trattare", "Attivi mirati per luminosità, tono ed elasticità."], ["Proteggere", "Formule leggere che sigillano l'idratazione."]],
      cta: "Chiedi la tua routine",
    },
    reviews: {
      over: "05 — Recensioni",
      title: "Le parole di chi ci sceglie",
      quotes: [
        "I trattamenti viso e corpo sono di alti livelli con ottimi risultati.",
        "Gioia è competente e molto professionale.",
        "Massima pulizia e igiene.",
      ],
      based: "su 26 recensioni Google",
      leave: "Lascia una recensione",
    },
    booking: {
      consent: "Ho letto l'informativa privacy e acconsento al trattamento dei dati per gestire la richiesta.",
      refCode: "Codice amica (facoltativo)",
      privacy: "Informativa privacy",
      over: "07 — Appuntamento",
      title: ["Riserva il tuo", "momento."],
      sub: "Compila il modulo e ti ricontatteremo per confermare, oppure prenota subito online o su WhatsApp.",
      name: "Nome e cognome", phone: "Telefono", email: "Email (facoltativa)", service: "Trattamento", date: "Data preferita", time: "Orario preferito", notes: "Note",
      choose: "Scegli un trattamento",
      times: ["Mattina", "Pausa pranzo", "Pomeriggio", "Sera"],
      send: "Invia richiesta", sending: "Invio in corso…",
      ok: "Richiesta inviata. Ti contatteremo a breve.", err: "Qualcosa è andato storto. Riprova o scrivici su WhatsApp.",
      direct: "Prenotazione immediata",
      vcal: "Prenota online", vcalSub: "Calendario in tempo reale su vcalendar.it",
      wa: "WhatsApp", waSub: PHONE_DISPLAY,
      call: "Chiama", callSub: "Parla direttamente con Gioia",
    },
    contact: {
      over: "08 — Dove siamo", title: "Vieni a trovarci", hours: "Orari", hoursVal: "Apertura dalle 09:00 · su appuntamento",
      address: "Indirizzo", directions: "Indicazioni", follow: "Seguici su Instagram", ig: "@gioia.centroestetico",
    },
    footer: {
      rights: "Tutti i diritti riservati.", tag: "Centro Estetico & Skincare", privacy: "Privacy & Cookie",
      piva: "P.IVA", rea: "REA",
    },
    gift: {
      over: "06 — Buoni regalo", title: ["Regala un momento", "da Gioia."],
      sub: "Scegli l'importo o dedica il buono a un trattamento. Paghi online in sicurezza e ricevi subito il buono via email, pronto da stampare o inoltrare.",
      amount: "Importo", other: "Altro", custom: "Importo libero (€20 – €1000)",
      treatment: "Trattamento (facoltativo)", any: "Trattamento a scelta",
      from: "Il tuo nome", email: "La tua email", to: "Nome del destinatario", message: "Dedica (facoltativa)",
      pay: "Paga e ricevi il buono", paying: "Reindirizzamento…", secure: "Pagamento sicuro con carta tramite Stripe",
      card: "Gift card", forLabel: "Per", valid: "Valido 12 mesi", err: "Impossibile avviare il pagamento. Riprova.",
      invalid: "Inserisci un importo tra €20 e €1000.",
    },
    payment: {
      checking: "Verifica del pagamento in corso…", successTitle: "Grazie! Il buono è pronto.",
      successSub: "Ti abbiamo inviato il buono via email. Conserva il codice qui sotto.", code: "Codice buono",
      cancelTitle: "Pagamento annullato", cancelSub: "Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.",
      failTitle: "Pagamento non completato", failSub: "Il pagamento non è andato a buon fine o è scaduto.",
      back: "Torna al sito", retry: "Riprova",
    },
  },
  en: {
    nav: { about: "Philosophy", services: "Treatments", results: "Results", skincare: "Skincare", shop: "Shop", gift: "Gift", blog: "Blog", reviews: "Reviews", contact: "Contact", book: "Book" },
    hero: {
      over: "Beauty Centre · Catanzaro",
      lines: ["Beauty is", "a ritual", "of precision."],
      sub: "Pro-age facials, body contouring and advanced treatments, performed with method, impeccable hygiene and Gioia's expert touch.",
      cta: "Book a treatment",
      wa: "Message us on WhatsApp",
      rating: "26 Google reviews",
      open: "Opens at 09:00",
      scroll: "Scroll",
    },
    marquee: ["Pro-Age Facial", "Body Slimming", "Aesthetic Mesotherapy", "Laser Hair Removal", "Lipolaser", "Massage", "Gioia Skincare", "Manicure"],
    about: {
      over: "01 — Philosophy",
      title: ["A place where care", "becomes", "results."],
      p1: "Gioia Centro Estetico was born from a simple idea: every treatment should be measurable. Brighter skin, a more defined silhouette, hands that always look cared for.",
      p2: "Listening, assessment, a tailored protocol. Nothing is left to chance, and a spotless environment is part of the ritual.",
      stats: [["4.8", "average rating"], ["13", "treatments"], ["100%", "sanitised protocols"]],
      sign: "— Gioia Anfosso",
      role: "Founder & owner",
    },
    services: { over: "02 — Treatments", title: "The beauty menu", sub: "Six areas of expertise, one focus: your skin.", book: "Book", quiz: "Not sure? Take the quiz (IT)" },
    beforeAfter: {
      over: "03 — Results", title: ["Before", "& after"],
      sub: "Drag the slider to reveal the difference. Every programme is tailored and results vary from person to person.",
      before: "Before", after: "After", drag: "Drag to compare",
      disclaimer: "Demonstration images. Real client photos coming soon.",
    },
    skincare: {
      over: "04 — The line",
      title: "Gioia Skincare",
      sub: "Our cosmetics line, born in the treatment room and formulated with plant-based ingredients, to extend your results at home.",
      line: "Nature line · plant-based ingredients",
      products: [["Orange face cream", "Vitamin C", "Radiance and an even complexion."], ["Calendula face cream", "Sensitive skin", "Soothing and protective for delicate skin."]],
      steps: [["Cleanse", "Gentle textures that respect the skin barrier."], ["Treat", "Targeted actives for radiance, tone and elasticity."], ["Protect", "Light formulas that lock in hydration."]],
      cta: "Ask for your routine",
    },
    reviews: {
      over: "05 — Reviews",
      title: "In our clients' words",
      quotes: [
        "Face and body treatments are top level, with excellent results.",
        "Gioia is skilled and highly professional.",
        "Utmost cleanliness and hygiene.",
      ],
      based: "from 26 Google reviews",
      leave: "Leave a review",
    },
    booking: {
      consent: "I have read the privacy policy and consent to data processing to handle my request.",
      refCode: "Friend code (optional)",
      privacy: "Privacy policy",
      over: "07 — Appointment",
      title: ["Reserve your", "moment."],
      sub: "Fill in the form and we'll get back to confirm, or book instantly online or on WhatsApp.",
      name: "Full name", phone: "Phone", email: "Email (optional)", service: "Treatment", date: "Preferred date", time: "Preferred time", notes: "Notes",
      choose: "Choose a treatment",
      times: ["Morning", "Lunch break", "Afternoon", "Evening"],
      send: "Send request", sending: "Sending…",
      ok: "Request sent. We'll be in touch shortly.", err: "Something went wrong. Try again or message us on WhatsApp.",
      direct: "Instant booking",
      vcal: "Book online", vcalSub: "Live calendar on vcalendar.it",
      wa: "WhatsApp", waSub: PHONE_DISPLAY,
      call: "Call", callSub: "Speak directly with Gioia",
    },
    contact: {
      over: "08 — Find us", title: "Come and visit", hours: "Hours", hoursVal: "Open from 09:00 · by appointment",
      address: "Address", directions: "Directions", follow: "Follow us on Instagram", ig: "@gioia.centroestetico",
    },
    footer: {
      rights: "All rights reserved.", tag: "Beauty Centre & Skincare", privacy: "Privacy & Cookies",
      piva: "VAT", rea: "REA",
    },
    gift: {
      over: "06 — Gift cards", title: ["Gift a moment", "at Gioia."],
      sub: "Choose an amount or dedicate the card to a treatment. Pay securely online and receive the gift card by email instantly, ready to print or forward.",
      amount: "Amount", other: "Other", custom: "Custom amount (€20 – €1000)",
      treatment: "Treatment (optional)", any: "Any treatment",
      from: "Your name", email: "Your email", to: "Recipient's name", message: "Message (optional)",
      pay: "Pay & get the gift card", paying: "Redirecting…", secure: "Secure card payment via Stripe",
      card: "Gift card", forLabel: "For", valid: "Valid 12 months", err: "Could not start payment. Please try again.",
      invalid: "Enter an amount between €20 and €1000.",
    },
    payment: {
      checking: "Checking your payment…", successTitle: "Thank you! Your gift card is ready.",
      successSub: "We've emailed you the gift card. Keep the code below.", code: "Gift card code",
      cancelTitle: "Payment cancelled", cancelSub: "You have not been charged. You can try again anytime.",
      failTitle: "Payment not completed", failSub: "The payment failed or expired.",
      back: "Back to site", retry: "Try again",
    },
  },
};

const LangCtx = createContext({ lang: "it", setLang: () => {}, t: T.it });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("gioia-lang") || "it");
  useEffect(() => {
    localStorage.setItem("gioia-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: T[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
